// @flow
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formValueSelector, change } from "redux-form";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import type { FieldProps } from "redux-form";

type SelectFieldType = {
    inputComponent: Element,
    children: Element | Array<Element>,
    changeSelect: Function,
    region: string,
} & FieldProps;

const RFSelectField = (props: SelectFieldType) => {
    const {
        input,
        inputComponent,
        meta: { touched, error },
        children,
        changeSelect,
        ...custom
    } = props;

    return (
        <FormControl required fullWidth error={touched && error}>
            <Select
                input={inputComponent}
                {...input}
                onChange={event => input.onChange(event)}
                {...custom}
                className="form__select"
            >
                {children}
            </Select>
            {touched && error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
};

const formSelector = formValueSelector("event");

const mapStateToProps = state => ({
    region: formSelector(state, "region"),
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ changeSelect: change }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RFSelectField);
